import { call, put } from 'redux-saga/effects'
import { apiConfig } from '../../../../../config/api-config'
import { makeAccess } from '../../../../../config/factory-controller'
import type { GenerateTokenRequest } from '../../../domain/models/reset-password'
import { AuthorizationTokenService } from '../../../service/authorization-token-service'
import * as action from '../actions/reset-password-actions'

export const generateTokenController = async (payload: GenerateTokenRequest) => {
  const { key, token } = await makeAccess()
  const dataSource = new AuthorizationTokenService(apiConfig(key, token))
  const result = await dataSource.generateToken(payload)
  
  return result
}

export function* generateTokenSaga({ payload }: any): any {
  try {
    const result = yield call(generateTokenController, payload)
    if (result.success) {
      yield put(action.generateTokenSuccess(result))
    } else {
      yield put(action.generateTokenError(result.message))
    }
  } catch (error: any) {
    yield put(action.generateTokenError(error.toString()))
  }
}